var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_vm._v("\n   "+_vm._s(_vm.moment(_vm.params.value).format('DD/MM/YYYY HH:mm'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }